import React from 'react'

export const Spinner = () => {
    return (
        <div className="lds-dual-ring"></div>
    )
}
